import { Box, Button, Center, Heading, Text, useMediaQuery, VStack } from "@chakra-ui/react";
import { useGetTransferHistoryByIdQuery } from "apis";
import { PaymentSuccessIllustrationSVG } from "assets";
import { ActionBar, Link, PageMotion, PaymentStatusStepper, PoweredBy } from "components";

import { useEffect, useState } from "react";
import ls from "utils/secureStorage";
import configs from "config";
import { useNavigate, useParams } from "react-router";

const PaymentSuccessView = () => {
  const { id: transferId } = useParams();

  const handleClose = () => {
    const URL = ls.get(configs.PERSIST_URL);
    window.location.replace(`/${URL}`);
  };

  const [pollingInterval, setPollingInterval] = useState(5000);
  const { data, isSuccess } = useGetTransferHistoryByIdQuery(transferId!, {
    skip: transferId ? false : true,
    pollingInterval,
  });

  useEffect(() => {
    (data?.status === "TransferComplete" || data?.status === "TransferCancelled" || data?.status === "TransferFailed") &&
      setPollingInterval(0);
  }, [data?.status]);

  const [payStatus, setPayStatus] = useState({
    title: "Processing",
    description: "We are confirming your payment. We will process your transaction shortly",
  });

  useEffect(() => {
    if (
      data?.paymentStatus === "PaymentFailed" ||
      data?.paymentStatus === "PaymentCancelled" ||
      data?.status === "TransferCancelled" ||
      data?.status === "TransferFailed"
    ) {
      setPayStatus({
        description: "",
        title: "Transaction Failed",
      });
    }

    if (data?.paymentStatus === "PaymentConfirmed") {
      setPayStatus({
        title: "Payment Received",
        description: "We have received your payment",
      });
    }

    if (data?.status === "TransferComplete") {
      setPayStatus({
        title: "Transfer Completed",
        description: "Transfer completed successfully",
      });
    }

    if (data?.status === "TransferCancelled" || data?.status === "TransferFailed") {
      setPayStatus({
        title: "Transfer Failed",
        description: "Transfer could not be completed",
      });
    }
  }, [data]);

  const navigate = useNavigate();

  const [isMobile] = useMediaQuery("(max-width: 650px)");

  return (
    <PageMotion px="16px">
      <Box maxW="720px" m="0 auto" pos="relative">
        <ActionBar onBackClick={() => navigate(-1)} title="Payment" />

        <Box minH="70vh">
          <VStack color="white" my="40px" bg="primary.default" borderRadius="10px" p="20px">
            <Box borderRadius="50%" bg="#E8C229" boxSize="104px" display="flex" justifyContent="center" alignItems="center">
              <Box as={PaymentSuccessIllustrationSVG} />
            </Box>

            <Heading my="30px !important" as="h4" fontSize="32px">
              {payStatus.title}!
            </Heading>
            <Text fontWeight="500" textAlign="center">
              {payStatus.description}
            </Text>
          </VStack>

          <VStack my="40px !important">
            <Text fontSize="md" fontWeight="600">
              Transaction Id
            </Text>

            <Link to={`/transaction/${transferId}`} textDecoration="underline" color="secondary.default" fontWeight="500">
              {transferId}
            </Link>

            <Center width={{ base: "initial", md: "100%" }}>
              {isSuccess && (
                <PaymentStatusStepper
                  orientation={isMobile ? "vertical" : "horizontal"}
                  isMobile={isMobile!}
                  paymentStatus={data?.paymentStatus!}
                  transferStatus={data?.status!}
                  reason={data?.reason ? data.reason : ""}
                />
              )}
            </Center>
            {/* </Center> */}

            <Button
              minW="160px"
              w="fit-content"
              mt="20px !important"
              variant="transparent"
              fontWeight="500"
              textDecoration="underline"
              onClick={handleClose}
            >
              Close
            </Button>
          </VStack>
        </Box>
      </Box>
      <PoweredBy />
    </PageMotion>
  );
};

export default PaymentSuccessView;
